import { restoreNotificationsBulkActionType } from '../../../../../backend/features/inbox';
import { showAlertNotificationRowDialog } from '../../../../../ui/components/AlertNotificationRowDialog';
import { useAlertUiTranslation, useUserState } from '../../../../../ui/hooks';
import { getNotificationBulkActionParams } from '../../../../../ui/utils';
import { useDataTableUsingUrl } from '@juvare/common-data-table-ui/DataTable';
import { useFilterConfig } from '@juvare/common-data-table-ui/FiltersBar';
import { showConfirmDialog } from '@juvare/common-web-ui/DialogHelper';
import { requireAnyOrgPermission } from '@juvare/contact-management/backend/features/permissions/shared';
import { launchBulkAction } from '@juvare/platform-sdk-react/ui/features/bulk-actions';
import UnarchiveOutlinedIcon from '@mui/icons-material/UnarchiveOutlined';
import { Box, Typography } from '@mui/material';
import React from 'react';
import alertImage from '../../../../assets/alertImage.svg';
import { useAlertCreateButton, useAlertRefreshButton } from '../../../alerts';
import { useInboxTable } from '../../hooks';
import { InboxNotificationView } from '../InboxNotificationView/InboxNotificationView';
import { NotificationsList } from '../NotificationsList';
export const NotificationsListInboxArchived = () => {
    var _a;
    const { t } = useAlertUiTranslation();
    const userState = useUserState();
    const filterConfig = useFilterConfig((builder) => {
        const search = builder.quickSearchFilter({ dataPath: 'searchText', label: t('common.search') });
        const notificationType = builder.quickFilterMultiSelect({
            dataPath: 'notificationType',
            label: t('pages.tables.filters.notificationType'),
            valueProviderType: 'classifier.messageType',
            widget: 'form.checkboxList',
        });
        const status = builder.quickFilterMultiSelect({
            dataPath: 'status',
            label: 'Status',
            values: [
                { label: 'Read', value: 'read' },
                { label: 'Unread', value: 'unread' },
                { label: 'Waiting For Response', value: 'waiting' },
            ],
            widget: 'form.checkboxList',
        });
        builder.allFiltersPanel({
            children: [search, notificationType, status],
        });
    }, [t]);
    const handleRowClickDialog = (alertRowId) => {
        showAlertNotificationRowDialog({
            type: 'notification',
            onClearActiveRow: clearActiveRow,
            onReload: reload,
            label: t('common.backToNotifications'),
            rowId: alertRowId,
        });
    };
    const staticFilterData = { archived: true };
    const { dataTableProps, appliedFilterData, clearActiveRow, reload } = useInboxTable({
        useDataTableFunction: useDataTableUsingUrl,
        staticFilterData: staticFilterData,
        filterConfig,
        handleRowClickDialog,
    });
    const selectedNotificationIds = (_a = dataTableProps.selectedRowIds) !== null && _a !== void 0 ? _a : [];
    const handleRestore = () => {
        const count = selectedNotificationIds.length > 0 ? selectedNotificationIds.length : dataTableProps.filteredRowCount;
        showConfirmDialog({
            title: t('restoreArchivedAlertsDialog.title', { count }),
            content: t('restoreArchivedAlertsDialog.message', { count, page: 'Inbox' }),
            confirmLabel: t('common.restore'),
            onConfirm: () => launchBulkAction({
                type: restoreNotificationsBulkActionType,
                title: t('restoreArchivedAlertsDialog.progress', { count }),
                params: getNotificationBulkActionParams(dataTableProps, appliedFilterData, staticFilterData),
                onClose: () => {
                    var _a;
                    clearActiveRow();
                    (_a = dataTableProps.onDeselectAllRows) === null || _a === void 0 ? void 0 : _a.call(dataTableProps);
                    reload();
                },
            }),
        });
    };
    const actions = [
        {
            icon: React.createElement(UnarchiveOutlinedIcon, null),
            label: t('common.restore'),
            onClick: handleRestore,
            'data-test': 'restore',
        },
    ];
    const mainAction = useAlertCreateButton();
    const secondaryAction = useAlertRefreshButton(() => reload());
    return (React.createElement(NotificationsList, Object.assign({}, dataTableProps, { title: t('pages.tables.tabs.archived'), noNotificationsLabel: t('common.thereAreNoArchivedAlerts'), localActions: actions, mainAction: requireAnyOrgPermission(userState, 'view-and-message-members', 'create-notifications') ? mainAction : undefined, secondaryAction: secondaryAction }), dataTableProps.activeRowId ? (React.createElement(InboxNotificationView, { id: dataTableProps.activeRowId, onReload: (clearActiveAlert) => {
            if (clearActiveAlert) {
                clearActiveRow();
            }
            reload();
        } })) : (React.createElement(Box, { sx: { display: 'flex', flexDirection: 'column', gap: 2, px: 2, py: '180px', alignItems: 'center' } },
        React.createElement("img", { src: alertImage, alt: '' }),
        React.createElement(Typography, { variant: 'subtitle1' }, t('common.countArchivedAlertsSelected', { count: selectedNotificationIds.length }))))));
};
